'use strict';
import {Component, Inject, Input} from 'ng-metadata/core';
import  'angular-material';
import {AddQueryToSavedSearchesService} from './addQueryToSavedSearches.service';
import {MediaQueries} from "../../../infra/mediaQueries.service";

@Component({
    'selector': 'prm-add-query-to-saved-searches',
    templateUrl: 'components/search/savedQueries/addQueryToSavedSearches/add-query-to-saved-searches.html'
})


export class PrmAddQueryToSavedSearches{
    @Input() isTabDisabled = false;
    private id:string;
    constructor(private addQueryToSavedSearchesService:AddQueryToSavedSearchesService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('featuredActionsIcons') private actionsIcons,
                private mediaQueries: MediaQueries) {
    }

    private add(){
        this.addQueryToSavedSearchesService.addItems().then((res) =>{
            let templateString = '<prm-add-alert-toast id="' + res.id + '" add-mode="' + true + '" user-email="' + res.email + '"></prm-add-alert-toast>';

            this.$mdToast.show({
                hideDelay   : 8000,
                position    : 'top right',
                template : templateString
            }).then(()=>{this.addQueryToSavedSearchesService.onToastClose()});
        }, (reason) => {
            console.log('add failed: ',reason);
        });
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.directive.ts